<template lang="html">
  <div class="model" @click="closeModel">
    <div class="model-body">
      <div class="model-header">
        请选择性别
      </div>
      <div class="model-content">
        <div v-for="item of list" @click.prevent="selectKey(item.value)" :key="item.name" class="model-item">
          <div class="">
            <span>{{item.label}}</span>
            <span class="code"></span>
          </div>
          <img v-if="getChecked(item.value)" src="../assets/images/checked.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    change: {
      type: Function
    }
  },
  data () {
    return {
      list: [
        { label: '男', value: 0 },
        { label: '女', value: 1 }
      ]
    }
  },
  methods: {
    closeModel () {
      this.$emit('close')
    },
    selectKey (value) {
      this.$emit('change', value)
    },
    getChecked (value1) {
      return Object.is(value1, this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 99;
  transform:translateZ(1px);
  background: rgba(60,60,67,0.6);
  .model-body {
    border-radius: 16px 16px 0 0;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 210px;
    background: #fff;
    box-shadow:0px -2px 12px 0px rgba(0,0,0,0.1);
    border-radius:16px 16px 0px 0px;
    box-sizing: border-box;
    padding: 0 24px;
    width: 100vw;
    .model-header {
      height:22px;
      font-size:17px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(60,60,67,0.6);
      line-height:22px;
      padding: 12px 0 8px 0;
      border-bottom: 1px solid #F2F2F7;
    }
    .model-content {
      max-height: calc(50vh - 46px);
      overflow-y: scroll;
      .model-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 18px 0;
        box-sizing: border-box;
        width: 100%;
        z-index: 999999;
        border-bottom: 1px solid #F2F2F7;
        span {
          font-size:17px;
          font-family:PingFangSC-Semibold,PingFang SC;
          font-weight: bold;
          color:rgba(51,51,51,1);
          line-height:22px;
        }
        .code {
          margin-left: 9px;
          font-weight: normal;
        }
      }
    }
  }
}
</style>
